import "./feature_discovery_component.scss"